import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import './css/dashboard.css';
import withAuth from './../auth_components/js/withAuth';
import AuthService from './../auth_components/js/AuthService';
import NavBar from './HeaderComponents/Navbar';
import News from './News/News';
import MainHome from './MainHome';

class DashBoard extends Component {
  constructor(Props) {
    super(Props);
    this.Auth = new AuthService();
  }

  logoutButton() {
    this.Auth.logout();
    this.props.history.replace('/login');
  }
  render() {
    return (
      <div>
        <NavBar onLogout={this.logoutButton.bind(this)} />
      </div>
    )
  }
}

export default withAuth(DashBoard);


// WEBPACK FOOTER //
// ./src/HomeComponents/DashBoard.js